<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Admission Helpline</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Admission Helpline</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="student-scholarship ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table width="100%" class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 35%">Section</th>
                <th style="width: 65%">Phone Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Admission Helpline</td>
                <!-- <td  style="text-align: center;"><a href="tel:8551098007">8551098007</a>,&nbsp;<a href="tel:9307900681">9307900681</a></td> -->
                <td>
                  <a href="tel:7720088580" class="text-dark">7720088580,&nbsp;
                  </a><a href="tel:8975002078" class="text-dark">
                    8975002078
                  </a>
                </td>
              </tr>
              <tr>
                <td>Whats app No.</td>
                <td><a
                    href="https://api.whatsapp.com/send?phone=+918605625522&amp;text=Hi, I need assistance for Admission at your GHRCACS Institute for Academic Year 2021-22."
                    target="_blank" class="text-dark">+918605625522</a></td>
                <!--<td style="text-align: center;">+91-8605625522</td>-->
              </tr>
              <tr>
                <td>Admission Email-ID</td>
                <td>
                  <!-- <a href="#" class="text-dark">enquiry.admissions@raisoni.net</a> -->
                  <a href="#" class="text-dark"> admission@ghrcacs.raisoni.net </a>
                  <!--<a href="#"> saminder@rietjaipur.ac.in </a>-->
                </td>
              </tr>
              <tr>
                <td>Campus Address</td>
                <td>Gate No. 1200 Wagholi, Pune – 412207
                </td>
              </tr>
              <tr>
                <td>Corporate Office Address:</td>
                <td>Raisoni Group of Institutions,
                  <br> 345, Shradha House (First Floor), Kingsway, Nagpur – 440 028
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <em class="text-center">The admission helpline is operational from 9:00 am to 6:30 pm.</em>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
